module.exports = __webpack_public_path__ + "static/media/RESUME_megumihiramoto.454422dd.PNG";